import { FC, memo, useContext } from 'react'
import { ScreenContext } from 'react-components'

import { Container, DestinationContainer, InnerContainer } from './styles'
import {
    CMSPopularDestinationTransport,
    PopularDestinationsSectionTransport,
    PopularDestinationTransport,
} from '../../../transports/region-landing-page-transport'
import { Subtitle, Title, TitleContainer } from '../common/styles'
import BestDestinationCard from './destination-card'
import { useResponsiveValue } from '../../../hooks/responsive'
import { EmblaCarousel } from '../../common/embla-carousel'

interface BestDestinationsProps {
    popularDestinationsSection: PopularDestinationsSectionTransport
    cmsPopularDestinationsSection: CMSPopularDestinationTransport
}

const breakpoints = [
    { query: '(max-width: 399px)', value: 2.2 },
    { query: '(min-width: 400px) and (max-width: 479px)', value: 2.6 },
    { query: '(min-width: 480px) and (max-width: 519px)', value: 2.8 },
    { query: '(min-width: 520px) and (max-width: 639px)', value: 3.5 },
    { query: '(min-width: 640px) and (max-width: 767px)', value: 3.9 },
    { query: '(min-width: 768px) and (max-width: 1023px)', value: 4.6 },
    { query: '(min-width: 1024px)', value: 6 },
]

const BestDestinationsSection: FC<BestDestinationsProps> = ({
    popularDestinationsSection,
    cmsPopularDestinationsSection,
}) => {
    const { heading, subheading, popularDestinations: regions } = popularDestinationsSection
    const { isDesktop } = useContext(ScreenContext)

    const popularDestinationSectionHeading = cmsPopularDestinationsSection?.heading ?? heading

    const visibleSlides = useResponsiveValue(breakpoints, 1.5)

    return (
        <Container id="best-destinations">
            <TitleContainer>
                <Title>{popularDestinationSectionHeading}</Title>
                <Subtitle>{subheading}</Subtitle>
            </TitleContainer>
            <InnerContainer>
                {isDesktop ? (
                    <DestinationContainer>
                        {regions.map((region: PopularDestinationTransport) => (
                            <BestDestinationCard key={region.url} {...region} />
                        ))}
                    </DestinationContainer>
                ) : (
                    <EmblaCarousel
                        slides={regions.map((region: PopularDestinationTransport) => (
                            <BestDestinationCard key={region.url} {...region} />
                        ))}
                        visibleSlides={visibleSlides}
                        slidesToScroll={Math.floor(visibleSlides)}
                    />
                )}
            </InnerContainer>
        </Container>
    )
}

export default memo(BestDestinationsSection)
